import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { customerSchema, type CustomerFormData } from '../schemas/customerSchema'
import { Input } from '@/components/ui/Input'
import { Select } from '@/components/ui/Select'
import { Textarea } from '@/components/ui/Textarea'
import { Button } from '@/components/ui/Button'

interface CustomerFormProps {
  initialData?: any
  onSubmit: (data: CustomerFormData) => Promise<void>
  onCancel: () => void
  loading?: boolean
}

export function CustomerForm({ initialData, onSubmit, onCancel, loading }: CustomerFormProps) {
  const { register, handleSubmit, formState: { errors } } = useForm<CustomerFormData>({
    resolver: zodResolver(customerSchema),
    defaultValues: initialData,
  })

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <Input label="Customer Name" {...register('name')} error={errors.name?.message} required />
      <Input label="Contact Person" {...register('contact_person')} error={errors.contact_person?.message} placeholder="Primary contact name" />
      <div className="grid grid-cols-2 gap-4">
        <Input label="Phone" type="tel" {...register('phone')} error={errors.phone?.message} />
        <Input label="Email" type="email" {...register('email')} error={errors.email?.message} />
      </div>
      <Input label="Address" {...register('address')} error={errors.address?.message} />
      <Select
        label="Contact Preference"
        {...register('contact_preference')}
        options={[
          { value: 'phone', label: 'Phone' },
          { value: 'email', label: 'Email' },
          { value: 'text', label: 'Text' },
          { value: 'in_person', label: 'In Person' },
        ]}
        error={errors.contact_preference?.message}
      />
      <Textarea label="Notes" {...register('notes')} error={errors.notes?.message} />
      <div className="flex justify-end space-x-3 pt-4">
        <Button type="button" variant="secondary" onClick={onCancel}>Cancel</Button>
        <Button type="submit" loading={loading}>{initialData ? 'Update' : 'Create'} Customer</Button>
      </div>
    </form>
  )
}
